const routes = [{
    path: '',
    component: () => import('@/shared/components/layout/Interno'),
    children: [
        {
            name: 'assinaturasAreaCliente',
            path: '/area_cliente/servicos_recorrentes',
            component: () => import('../views/Listar'),
        }
    ]
},
// GCK-20840: o detalhe da assinatura usa o shell próprio do portal (PortalLayout)
{
    name: 'visualizarAssinaturaAreaCliente',
    path: '/area_cliente/servicos_recorrentes/visualizar/:id',
    component: () => import('../views/Visualizar'),
}]

export default routes
